<template>
  <main>
    <router-view :userDoc2="userDoc2" :managerDoc2="managerDoc2"></router-view>
  </main>
</template>

<script>
export default {
  name: 'VueMain',
  props: {
    userDoc2: Object,
    managerDoc2: Object,
  },
};
</script>

<style scoped lang="scss">
main {
  height: 100%;
  width: 100%;
}
</style>
